<div class="modal-header">
    <h4 class="modal-title">Detalles de la {{element.tipo == 1 ? 'Orden de Trabajo' : element.tipo == 2 ? 'Venta' : 'Cotización'}} N° {{element.correlativo}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1">
            <a ngbNavLink>Detalles</a>
            <ng-template ngbNavContent>
                <form [formGroup]="form">
                    <div class="row">
                        <div class="col-12 col-sm" *ngIf="form.value.vehiculo_id">
                            <label for="vehiculo_id">Vehículo</label>
                            <ng-select [items]="vehiculos" formControlName="vehiculo_id" bindValue="id" labelForId="vehiculo_id"
                                [searchFn]="searchFn" [virtualScroll]="true" [readonly]="form.controls['vehiculo_id'].disabled"
                                bindLabel="patente"
                                [ngClass]="{'is-invalid': form.controls['vehiculo_id'].errors && form.controls['vehiculo_id'].touched}"
                                appendTo="body">
                                <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{item.patente}} - {{item.usuario ? item.usuario.nombre : 'Sin'}} {{item.usuario ?
                                    item.usuario.apellido : 'Dueño'}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{item.patente}} - {{item.usuario ? item.usuario.nombre : 'Sin'}} {{item.usuario ?
                                    item.usuario.apellido : 'Dueño'}}
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                        </div>
                
                        <div class="col-12 col-sm" *ngIf="form.value.tipo_revision_id">
                            <label for="tipo">Tipo Servicio</label>
                            <div class="form-group">
                                <select class="form-select" id="tipo" formControlName="tipo_revision_id"
                                    [ngClass]="{'is-invalid': form.controls['tipo_revision_id'].errors && form.controls['tipo_revision_id'].touched}">
                                    <ng-container *ngFor="let tipo of tipos">
                                        <option [value]="tipo.id">{{tipo.nombre}}</option>
                                    </ng-container>
                                </select>
                                <div class="invalid-feedback">
                                    Debe ingresar un valor en el campo
                                </div>
                            </div>
                        </div>
                
                        <div class="col-12 col-sm">
                            <label for="fecha">Fecha</label>
                            <input type="date" class="form-control" id="fecha" formControlName="fecha"
                                [ngClass]="{'is-invalid': form.controls['fecha'].errors && form.controls['fecha'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['fecha'].errors || !form.controls['fecha'].touched">
                            </div>
                        </div>
                    </div>
                
                    <div class="row">
                        <div class="col-12 col-sm" *ngIf="form.value.encargado_id">
                            <label for="encargado">Encargado</label>
                            <ng-select [items]="encargados" formControlName="encargado_id" bindValue="id" labelForId="encargado_id"
                                [searchFn]="searchFnEncargado" [virtualScroll]="true" [readonly]="form.controls['encargado_id'].disabled"
                                [ngClass]="{'is-invalid': form.controls['encargado_id'].errors && form.controls['encargado_id'].touched}"
                                appendTo="body">
                                <ng-template ng-label-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{formatter.nombreCompleto(item)}}
                                </ng-template>
                                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                                    {{formatter.nombreCompleto(item)}}
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['encargado_id'].errors || !form.controls['encargado_id'].touched">
                            </div>
                        </div>
                    </div>
                
                    <div class="row" *ngIf="element.tipo == 1">
                        <div class="col-12 col-sm-4">
                            <label for="kilometraje">Kilometraje</label>
                            <input type="number" class="form-control" id="kilometraje" formControlName="kilometraje"
                                [ngClass]="{'is-invalid': form.controls['kilometraje'].errors && form.controls['kilometraje'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4" *ngIf="!form.controls['kilometraje'].errors || !form.controls['kilometraje'].touched">
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <label for="proxima_revision">Kilometraje para próxima revisión</label>
                            <input type="number" class="form-control" id="proxima_revision" formControlName="proxima_revision"
                                [ngClass]="{'is-invalid': form.controls['proxima_revision'].errors && form.controls['proxima_revision'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4"
                                *ngIf="!form.controls['proxima_revision'].errors || !form.controls['proxima_revision'].touched">
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <label for="fecha_estimada">Estimado Siguiente Revisión</label>
                            <input type="date" class="form-control" id="fecha_estimada" formControlName="fecha_estimada"
                                [ngClass]="{'is-invalid': form.controls['fecha_estimada'].errors && form.controls['fecha_estimada'].touched}">
                            <div class="invalid-feedback">
                                Debe ingresar un valor en el campo
                            </div>
                            <div class="mb-4"
                                *ngIf="!form.controls['fecha_estimada'].errors || !form.controls['fecha_estimada'].touched">
                            </div>
                        </div>
                    </div>

                    <div class="mb-3">
                        <label for="tipo_pago">Método de Pago</label>
                        <select class="form-select" id="tipo_pago" formControlName="tipo_pago">
                            <option value="1">Efectivo</option>
                            <option value="2">Tarjeta Débito</option>
                            <option value="3">Tarjeta Crédito</option>
                            <option value="4">Transferencia</option>
                            <option value="5">Cheque</option>
                            <option value="6">Crédito</option>
                        </select>
                    </div>

                    <div class="mb-3">
                        <label for="tipo_documento">Tipo de Documento</label>
                        <select class="form-select" id="tipo_documento" formControlName="tipo_documento">
                            <option value="1">Boleta</option>
                            <option value="2">Factura</option>
                            <option value="3">Cotización</option>
                        </select>
                    </div>

                    <div class="form-group">
                        <label for="detalle">Detalles</label><label class="campo-opcional"> (Opcional)</label>
                        <textarea class="form-control" id="detalle" rows="6" formControlName="detalle"></textarea>
                    </div>
                </form>
            </ng-template>
        </li>
        <li [ngbNavItem]="2">
            <a ngbNavLink>Productos y Servicios</a>
            <ng-template ngbNavContent>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">Producto/Servicio</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Valor Unitario</th>
                            <th scope="col">SubTotal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of lineas; let index = index">
                            <td style="vertical-align: middle;" class="w-100">
                                {{item.producto?.nombre}}
                            </td>
                            <td style="min-width: 100px;vertical-align: middle;">{{formatter.numberFormat(item.cantidad)}}</td>
                            <td style="min-width: 150px;vertical-align: middle;">{{formatter.numberFormat(item.precio_unitario)}}</td>
                            <td class="text-right" style="min-width: 130px;vertical-align: middle;">$
                                {{formatter.numberFormat(item.precio_unitario * item.cantidad)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="3">
                                <div class="d-flex flex-column w-100">
                                    <div class="w-100 text-end">Neto</div>
                                    <div class="w-100 text-end">IVA (19%)</div>
                                    <div class="w-100 text-end">Total</div>
                                </div>
                            </th>
                            <th class="text-right">
                                <div class="d-flex flex-column w-100">
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total / 1.19, 0,0)}}</div>
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total / 1.19 * 0.19, 0,0)}}</div>
                                    <div class="w-100 text-end">$ {{formatter.numberFormat(total)}}</div>
                                </div>
                            </th>
                        </tr>
                    </tfoot>
                </table>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="border border-top-0 p-3"></div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cerrar</button>
</div>